import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  Stack,
  Divider,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const PlanCard = () => {
  return (
    <Card
      sx={{
        borderRadius: "12px",
        boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
        width: 300,
        padding: "20px",
        textAlign: "center",
      }}
    >
      <Typography variant="h5" fontWeight="bold" color="primary.main">
        Gold
      </Typography>
      <Typography variant="body2" color="textSecondary" mb={2}>
        Unlock essential features and customization options to keep your
        business billing streamlined and efficient.
      </Typography>
      <Divider sx={{ marginBottom: 2 }} />
      <Typography variant="h4" color="primary.main" fontWeight="bold">
        AUD$99/MO
      </Typography>
      <Button
        variant="contained"
        color="primary"
        sx={{ marginTop: 2, marginBottom: 2 }}
      >
        CHOOSE PLAN
      </Button>
      <Divider sx={{ marginBottom: 2 }} />
      <Stack spacing={1} alignItems="start">
        {[
          "10 Free Invoices",
          "100 Free Quotations",
          "Unlimited Invoice Reminder Templates",
          "100 RCTI",
          "Debt maintenance, resend emails & Download",
          "100 Expenses",
          "Email Reminder logs",
          "Unlimited Invoice Themes",
          "Report",
        ].map((feature, index) => (
          <Box key={index} sx={{ display: "flex", alignItems: "center" }}>
            <CheckCircleIcon sx={{ color: "#6ebe44", marginRight: 1 }} />
            <Typography variant="body2">{feature}</Typography>
          </Box>
        ))}
      </Stack>
    </Card>
  );
};

export default PlanCard;
